/* AJK SOUQ – product page effects: spotlight, lightning, rotating badges, live viewers, sticky ATC */
(function () {
  'use strict';

  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  var BOLT = '<svg class="ajk-fx__bolt ajk-fx__bolt--%s" viewBox="0 0 60 160" aria-hidden="true"><path d="M34 0 L18 52 L32 56 L10 112 L26 116 L14 160"/><path d="M34 0 L18 52 L32 56 L10 112 L26 116 L14 160"/></svg>';

  function mountFx() {
    var wrap = document.querySelector('.product__media-wrapper');
    if (!wrap || wrap.querySelector('.ajk-fx')) return;
    var fx = document.createElement('div');
    fx.className = 'ajk-fx';
    fx.setAttribute('aria-hidden', 'true');
    fx.innerHTML = '<div class="ajk-fx__spot"></div><div class="ajk-fx__flash"></div>' + BOLT.replace('%s', 'a') + BOLT.replace('%s', 'b');
    wrap.appendChild(fx);
    var spot = fx.querySelector('.ajk-fx__spot');
    wrap.addEventListener('pointermove', function (e) {
      var r = wrap.getBoundingClientRect();
      fx.classList.add('is-hover');
      spot.style.setProperty('--ajk-x', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      spot.style.setProperty('--ajk-y', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    });
    wrap.addEventListener('pointerleave', function () {
      fx.classList.remove('is-hover');
      spot.style.removeProperty('--ajk-x'); spot.style.removeProperty('--ajk-y');
    });
  }

  function rotators() {
    document.querySelectorAll('[data-ajk-rot]').forEach(function (box) {
      var items = box.querySelectorAll('.ajk-rot__item'); if (items.length < 2) return;
      var i = 0; items[0].classList.add('is-on');
      setInterval(function () {
        items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on');
      }, 3200);
    });
  }

  function viewers() {
    document.querySelectorAll('[data-ajk-viewers]').forEach(function (el) {
      var min = +el.getAttribute('data-min') || 28, max = +el.getAttribute('data-max') || 46;
      var n = Math.floor(Math.random() * (max - min + 1)) + min; el.textContent = n;
      setInterval(function () {
        n = Math.max(min, Math.min(max, n + (Math.random() > .5 ? 1 : -1) * (1 + Math.floor(Math.random() * 3))));
        el.textContent = n;
      }, 4500);
    });
  }

  function sticky() {
    var bar = document.querySelector('.ajk-sticky'); if (!bar) return;
    var target = document.querySelector('.product-form__submit'); if (!target) return;
    var btn = bar.querySelector('.ajk-sticky__btn');
    var show = function (v) { bar.classList.toggle('is-show', v); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0]; show(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(target);
    }
    btn.addEventListener('click', function () {
      var av = target.disabled;
      if (av) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { target.click(); }, 450);
    });
  }

  ready(function () { mountFx(); rotators(); viewers(); sticky(); });
})();
